import { render, staticRenderFns } from "./AddOrEditEntityType.vue?vue&type=template&id=bcca6c34&scoped=true"
import script from "./AddOrEditEntityType.vue?vue&type=script&lang=js"
export * from "./AddOrEditEntityType.vue?vue&type=script&lang=js"
import style0 from "./AddOrEditEntityType.vue?vue&type=style&index=0&id=bcca6c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcca6c34",
  null
  
)

export default component.exports